<template>
    <div class="skeleton-singer skeleton-el">
        <div class="block1 block"></div>
        <ul class="block2">
            <li v-for="item in 4" :key="(item + 1)" class="block"></li>
        </ul>
        <div class="block3 block"></div>
        <ul class="block4">
            <li v-for="item in 8" :key="(item + 1) * 10" class="block"></li>
        </ul>
        <div class="fetch-loading"><img src="../fetchLoading/imgs/icon3.png"></div>
    </div>
</template>
<script>
export default {
  name: 'SkeletonClassifySinger',
};
</script>
<style lang="scss" scoped>
.skeleton-singer {
    position: fixed;
    left: 0;
    top: 0;
    top: 130px;
    width: 100vw;
    height: 100vh;
    padding: 8px 30px 0;
    background: #fff;
    .block {
        background: #F0F0F0;
    }
    .block1 {
        width: 190px;
        height: 36px;
        border-radius: 18px;
    }
    .block2 {
        display: flex;
        margin: 26px 0 20px;
        li {
            width: 150px;
            height: 197px;
            margin-right: 20px;
        }
    }
    .block3 {
        height: 200px;
    }
    .block4 {
        @include SpaceBetween();
        flex-wrap: wrap;
        padding-bottom: 10px;
        li {
            width: 160px;
            height: 60px;
            border-radius: 30px;
            margin-top: 20px;
            &:nth-child(4n) {
                margin-right: 0;
            }
            &:last-child {
                visibility: hidden;
            }
        }
    }
}
</style>
